import { replaceAccent } from "./StringUtils";
/**
 * Utilitaire contenant des fonctions statiques pour les objets
 * @category Utils
 * @hideconstructor
 */

var ObjectUtils = /*#__PURE__*/function () {
  function ObjectUtils() {}

  /**
  * Teste si un objet est vide ou non
  * @param {object} object L'objet à tester
  * @returns {boolean} true si l'objet est vide, false sinon
  */
  ObjectUtils.isEmpty = function isEmpty(object) {
    if (!object) {
      return true;
    }

    if (Object.entries(object).length === 0 && object.constructor === Object) {
      return true;
    }

    return false;
  }
  /**
   * Comparaison de 2 objets
   * @param {object} object1 Objet 1 pour la comparaison
   * @param {object} object2 Objet 2 pour la comparaison
   * @returns {boolean} true si les objets sont égaux, false sinon
   */
  ;

  ObjectUtils.isEquals = function isEquals(object1, object2) {
    if (!object1 || !object2) {
      return false;
    }

    var result = true;
    var properties = Object.getOwnPropertyNames(object1);
    properties.forEach(function (item) {
      result = result && object1[item] === object2[item];
      return result;
    });
    return result;
  }
  /**
   * Renvoie une fonction qui trie un tableau d'objets en fonction de plusieurs champs
   * @param {...string} props Nom des champs sur lesquels trier. Ajouter un - devant le nom pour trier par ordre décroissant
   * @returns {Function} Une fonction qui trie 2 objets passés en paramètres selon la liste de champs _props_
   */
  ;

  ObjectUtils.multipleSortObject = function multipleSortObject() {
    var props = arguments;
    return function (obj1, obj2) {
      var i = 0,
          result = 0,
          numberOfProperties = props.length;

      while (result === 0 && i < numberOfProperties) {
        result = ObjectUtils.sortObject(props[i])(obj1, obj2);
        i++;
      }

      return result;
    };
  }
  /**
   * Renvoie une fonction qui trie un tableau d'objets en fonction d'un champ
   * @param {string} sortField Nom du champ sur lequel trier. Ajouter un - devant le nom pour trier par ordre décroissant
   * @param {boolean} [caseInsensitive=true] Le tri ne tient pas compte de la casse si le champ sur lequel trier est une chaine
   * @returns {Function} Une fonction qui trie 2 objets passés en paramètres selon le champ _sortField_
   */
  ;

  ObjectUtils.sortObject = function sortObject(sortField, caseInsensitive) {
    if (caseInsensitive === void 0) {
      caseInsensitive = true;
    }

    var sortOrder = 1;

    if (sortField[0] === "-") {
      sortOrder = -1;
      sortField = sortField.substr(1);
    }

    return function (a, b) {
      var valueA = a[sortField];
      var valueB = b[sortField];

      if (typeof valueA === "string" && typeof valueB === "string") {
        valueA = replaceAccent(valueA);
        valueB = replaceAccent(valueB);

        if (caseInsensitive) {
          valueA = valueA.toUpperCase();
          valueB = valueB.toUpperCase();
        }
      }

      var result = valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
      return result * sortOrder;
    };
  };

  return ObjectUtils;
}(); // Exports


export var isEmptyObject = ObjectUtils.isEmpty;
export var isEqualsObject = ObjectUtils.isEquals;
export var multipleSortObject = ObjectUtils.multipleSortObject;
export var sortObject = ObjectUtils.sortObject;